import React from 'react'
import { Alert, Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material'

const DeleteNoteDialog = ({ open, note, onDelete, onClose }) => {
  const handleClick = () => {
    onDelete(note)
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Delete Note</DialogTitle>
      <DialogContent>
        <Alert severity="warning">Are you sure to Delete Note?</Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>No</Button>
        <Button onClick={handleClick}>Yes</Button>
      </DialogActions>
    </Dialog>
  )
}
export default DeleteNoteDialog
